<script setup lang="ts">
import SlideOver from './SlideOver.vue'

const store = useStore()

const isVisible = computed(() => store.sidebarVisible)

const emit = defineEmits<{
  'update:isOpen': [value: boolean]
}>()

function closeMe() {
  emit('update:isOpen', false)
  store.sidebarVisible = false
}
</script>

<template>
  <SlideOver :is-visible="isVisible" @close="closeMe" />
</template>
